import $ from "jquery";
import app from "./src/App";

import "./components/Header.js";
import "./components/GlobalAnimations";
